const extractSignature = require('../extractSignature');
const extractLocation = require('../extractLocation');
const extractName = require('../extractName');
const extractNameExclusive = require('../extractNameExclusive');
const locationOrParty = require('../locationOrParty');
const {
    formatDateTime
} = require('gui');

module.exports = function createEvent(actualDateTime, estimatedDateTime, signature, location, partyName, extractAction) {
    const event = {
        time: formatDateTime(actualDateTime || estimatedDateTime, 'LT'),
        date: formatDateTime(actualDateTime || estimatedDateTime, 'L'),
        ticks: actualDateTime || estimatedDateTime,
        isActual: (actualDateTime !== undefined),
        signature: extractSignature(signature),
        signatureName: extractName(signature),
        signatureNameExclusive: extractNameExclusive(signature),
        location: extractLocation(location),
        name: partyName,
    };
    event.place = locationOrParty(event.location, partyName);
    event.placeAction = extractAction(event.isActual, event.location, partyName);
    return event;
};
